import { ArrowDownwardRounded, ArrowUpwardRounded } from "@mui/icons-material";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { SortByDirection, TaskItemsSortByOption } from "../../constants";

interface Props {
  sortByOption: TaskItemsSortByOption;
  sortByDirection: SortByDirection;
  disabledOptions?: {
    [key in TaskItemsSortByOption]?: boolean;
  };
  onSortByChanged: (value: TaskItemsSortByOption) => void;
  onSortDirectionChanged: (value: SortByDirection) => void;
}

const TaskItemsSortToggleButton = (props: Props) => {
  function handleSortByChanged(value: TaskItemsSortByOption) {
    if (value != null) {
      props.onSortByChanged(value);
    }
  }

  function handleSortDirectionChanged() {
    if (props.sortByDirection === SortByDirection.Ascending) {
      props.onSortDirectionChanged(SortByDirection.Descending);
    } else {
      props.onSortDirectionChanged(SortByDirection.Ascending);
    }
  }

  return (
    <ToggleButtonGroup
      value={props.sortByOption}
      exclusive
      orientation="vertical"
      variant="menu"
      onChange={(_, value) => handleSortByChanged(value)}
      sx={{ minWidth: "100%" }}
    >
      <ToggleButton
        value={TaskItemsSortByOption.DateCreated}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Date Created</Typography>
        {props.sortByOption === TaskItemsSortByOption.DateCreated ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
      <ToggleButton
        value={TaskItemsSortByOption.DateModified}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Date Modified</Typography>
        {props.sortByOption === TaskItemsSortByOption.DateModified ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
      <ToggleButton
        value={TaskItemsSortByOption.Name}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Name</Typography>
        {props.sortByOption === TaskItemsSortByOption.Name ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
      <ToggleButton
        disabled={props.disabledOptions && props.disabledOptions[TaskItemsSortByOption.Owners]}
        value={TaskItemsSortByOption.Owners}
        onClick={handleSortDirectionChanged}
        sx={{ justifyContent: "space-between !important" }}
      >
        <Typography>Owner</Typography>
        {props.sortByOption === TaskItemsSortByOption.Owners ? (
          props.sortByDirection === SortByDirection.Descending ? (
            <ArrowDownwardRounded />
          ) : (
            <ArrowUpwardRounded />
          )
        ) : null}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export { TaskItemsSortToggleButton };
